import React, {Component} from 'react';
import { Trans } from 'react-i18next';
import i18n from '../resources/i18n';

import LayoutSC from '../components/LayoutSC.jsx';

import LocalStorage from '../service/LocalStorage';
import { postRequest } from '../service/ApiService';

class ShoppingCart extends Component {

  constructor(props) {
    super(props);
    let checkStorage = LocalStorage.get('mac-items');
    if(checkStorage !== undefined){
      checkStorage = checkStorage.filter(it => this.checkDateRange(it.savedAt));
      if(checkStorage.length === 0){
        LocalStorage.delete('mac-items');
        checkStorage = undefined;
      }else{
        LocalStorage.put('mac-items', checkStorage);
      }
    }
    const items = checkStorage !== undefined ? checkStorage : [];
    this.state = {
      items: items,
    };
  }

  checkDateRange(timeAt){
    let auxDate = new Date();
    let savedAt = new Date(timeAt);
    auxDate.setHours(0,0,0,0);
    savedAt.setHours(0,0,0,0);
    let auxDif = auxDate.getTime() - savedAt.getTime();
    if(auxDif>=0 && auxDif<=604800000){// 7 días
      return true;
    }
    return false;
  }

  updateCartInLS = (newItems) => {
    LocalStorage.put('mac-items', newItems);
  }

  goMain = () => {
    window.location.href = '/mapaalacarta';
  }

  emptyCart = () => {
    LocalStorage.delete('mac-items');
    this.goMain();
  }

  emptyCartShop = () => {
    LocalStorage.delete('mac-items');
    // this.goMain();
  }

  pasteFix = (pst) => {
    if (/^\d*[1-9]\d*$/.test((pst.clipboardData || window.clipboardData).getData('text'))) {
      return false;
    }
    pst.preventDefault();
    return true;
  }

  keydownFix = (kdwn) => {
    if (kdwn.key.length === 1 && !(/[0-9]/.test(kdwn.key) || kdwn.altKey || kdwn.ctrlKey || kdwn.metaKey || kdwn.shiftKey)) kdwn.preventDefault();
  }

  updateQuantity = (id, subtitle, type, e) => {
    const newQuantity = e.target.value;
    const newItems = this.state.items;
    newItems.forEach((i) => {
      if (i.id === id && i.subtitle === subtitle && i.type === type) {
        i.quantity = newQuantity;
      }
    });

    this.setState({ items: newItems }, () => {
      this.updateCartInLS(newItems);
    });
  }

  removeItem = (id, subtitle, type) => {
    const newItems = [];
    this.state.items.forEach((i) => {
      if (!(i.id === id && i.subtitle === subtitle && i.type === type)) {
        newItems.push(i);
      }
    });

    if (newItems.length === 0) {
      this.emptyCart();
    } else {
      this.setState({ items: newItems }, () => {
        this.updateCartInLS(newItems);
      });
    }
  }

  doShopping = () => {
    const headers = {};
    headers["Content-Type"] = "application/json";
    headers["Access-Control-Allow-Origin"] = "*";
    const data = [];
    this.state.items.forEach((i) => {
      data.push({
        tipoImpresion: i.type,
        cantidad: i.quantity,
        urlPDF: i.url,
      });
    });

    postRequest('/conectorMAC/urlCompra', data, headers).then(response => {
      let responseData = JSON.parse(JSON.stringify(response.data));
      window.open(responseData.url, "_self");
      this.emptyCartShop();
    });
  }

  namedWithPaperType(paper){
    let result = '';
    switch(paper){
      case "Aventuraplegado":result = 'MapaResistentePlegado'; break;
      case "Normalplegado":result = 'MapaNormalPlegado'; break;
      case "Aventurasinplegar":result = 'MapaResistenteSinPlegar'; break;
      //case "Normalsinplegar":result = 'PosterNormalSinPlegar' OR 'MapaNormalSinPlegar'; break; //FIXED in REUSE PDF
      case "Normalsinplegar":result = 'MapaNormalSinPlegar'; break;
      case "PosterNormalsinplegar":result = 'PosterNormalSinPlegar'; break;
      case "FotoNormalsinplegar":result = 'FotoNormalSinPlegar'; break;
      case "Satinadosinplegar":result = 'PosterSatinadoSinPlegar'; break;
      case "Rigidosinplegar":result = 'PosterRigidoSinPlegar'; break;
      case "FotoRigidosinplegar":result = 'FotoRigidoSinPlegar'; break;
      case "Fotograficosinplegar":result = 'FotograficoSinPlegar'; break;
      case "PosterAventurasinplegar":result = 'PosterResistenteSinplegar'; break;
      case "FotoAventurasinplegar":result = 'FotoResistenteSinplegar'; break;
      default:result = 'MapaNormalSinPlegar';
    }
    return result
  }

  render() {
    const { items } = this.state;
    const renderedItems = [];
    let totalPrice = 0;
    items.forEach((i, index) => {
      totalPrice += (i.price * i.quantity);
      const name = i.title + ' - ' + this.namedWithPaperType(i.type);//((i.subtitle !== undefined && i.subtitle !== '') ? ` - ${i.subtitle}` : '');
      renderedItems.push(
        <tr key={i.id+index+i.subtitle+i.type}>
          <td>{name}</td>
          <td style={{ textAlign: 'right', width: '125px' }}>
            <a href={i.url} target='_blank' rel='noopener noreferrer'>
              <Trans i18nKey="shoppingCart.downloadMap">Descargar mapa</Trans>
            </a>
          </td>
          <td style={{ textAlign: 'center', width: '125px' }}>
            <input type="number" defaultValue={i.quantity} min="1" max="999" onChange={this.updateQuantity.bind(null, i.id, i.subtitle, i.type)} onPaste={this.pasteFix} onKeyDown={this.keydownFix} style={{ maxWidth: '125px'}}/>
          </td>
          <td style={{ textAlign: 'right', width: '250px' }}>
            <span>{(i.price * i.quantity).toFixed(2)}€</span>
            <br/>
            <span>{i.price}€/<Trans i18nKey="shoppingCart.unity">Unidad</Trans></span>
          </td>
          <td style={{ textAlign: 'right', width: '15px' }}>
            <span title={i18n.t('shoppingCart.removeProduct')} style={{ cursor: 'pointer' }} onClick={this.removeItem.bind(null, i.id, i.subtitle, i.type)}>
              <i className='far fa-trash-alt'></i>
            </span>
          </td>
        </tr>
      );
    });

    return (
      <LayoutSC>
        <div className='shopping-cart-layout'>
          <div style={{ maxWidth: '950px', margin: 'auto' }}>
            <p className='shopping-cart-title'><Trans i18nKey="shoppingCart.cartDetail">Detalle carrito</Trans></p>
            <div>
              <div className='shopping-cart-table-container'>
                <table className='shopping-cart-table'>
                  <thead>
                    <tr>
                      <td colSpan="2">
                        <Trans i18nKey="shoppingCart.name">name</Trans>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <Trans i18nKey="shoppingCart.units">Unidades</Trans>
                      </td>
                      <td colSpan="2" style={{ textAlign: 'center' }}>
                        <Trans i18nKey="shoppingCart.priceWithoutIVA">Precio (sin IVA)</Trans>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {renderedItems}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="5">
                        <span style={{ marginRight: '60px',whiteSpace: 'nowrap'}}>
                          <Trans i18nKey="shoppingCart.totalWithoutIVA">Total (sin IVA)</Trans>
                        </span>
                        <span>{totalPrice.toFixed(2)}€</span>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div className='shopping-cart-buttons'>
              <button onClick={this.goMain}>
                <i className='far fa-plus'></i>&nbsp;&nbsp;<Trans i18nKey="shoppingCart.addMoreMaps">Añadir más mapas</Trans>
              </button>
              <button onClick={this.doShopping}>
                <i className='far fa-euro-sign'></i>&nbsp;&nbsp;<Trans i18nKey="shoppingCart.buy">Comprar</Trans>
              </button>
              <button onClick={this.emptyCart}>
                <i className='far fa-trash-alt'></i>&nbsp;&nbsp;<Trans i18nKey="shoppingCart.emptyCart">Vaciar carrito</Trans>
              </button>
            </div>
          </div>
        </div>
      </LayoutSC>
    );
  }
}

export default ShoppingCart;
